<template>

  <section class="pied-creer-billetterie">
    <div class="section" id="CallToAction">
        <div class="container">
            <h2>Voulez-vous <br> créer votre billetterie ?</h2>
            <btn-commencer/>
        </div>
    </div>
  </section>

</template>

<script lang="js">
  import BtnCommencer from '@/components/BtnCommencer.vue'

  export default  {
    name: 'pied-creer-billetterie',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    },
    components: {
      BtnCommencer
    }
}
</script>

<style>
  #CallToAction{
    padding: 7em 0;
    background-color: var(--sk-darkblue);
    background-image: url(../assets/img/calltoaction_organiser.png);
    background-repeat: no-repeat;
    background-position: top right;
    background-size: auto 100%;
  }

  #CallToAction h2{
    color: #fff;
    font-size: 3.5em;
    margin-bottom: .6em;
  }
</style>

